module.exports = __webpack_public_path__ + "static/4-e4c3f5fd7ad666b85f96fb068e4f2b4c.png";